import Plyr from 'plyr';
// import player from "@vimeo/player/dist/player";

$(document).ready(function () {
    const MAX_INIT_SLIDES = 10;
    let itemIndex = -1;
    let itemLength = $('.reels-list .item').length

    let popPlayer = new Plyr($('#pop-video .video-content'), {
        autoplay: false,
        muted: true,
        loop: { active: true },
        controls: ['play', 'progress', 'current-time', 'mute', 'volume'],
        vimeo: {
            loop: true
        }
    });
    // 綁定點擊事件到 player 的容器
    bindPlayerEvent(popPlayer)

    let players = {};
    // 初始化前 10 個影片 Plyr
    setTimeout(function(){
        $('.plyr-player').each(function (index) {
            if (index < MAX_INIT_SLIDES) {
                let mbItem = $('.videobox-mb .video-wrapper .video').eq(index);
                if (mbItem.length === 1) {
                    let item = $('.reels-list .item').eq(index)
                    rebind(item, mbItem)
                }

            }
        });
        // console.log('players 1 =====')
        // console.log(players)
    }, 300);

    // Initialize Swiper
    const swiper = new Swiper('.swiper', {
        direction: 'vertical',
        // 其他設定
        on: {
            slideChange: () => { // 滑動事件
                itemIndex = swiper.activeIndex;
                // console.log('slideChange 1 === '+ itemIndex)

                $('.plyr-player').each(function (index) {
                    if (index < (itemIndex + MAX_INIT_SLIDES)) {
                        let mbItem = $('.videobox-mb .video-wrapper .video').eq(itemIndex);

                        if (!players[$(mbItem).data('id')]) {
                            if (mbItem.length === 1) {
                                let item = $('.reels-list .item').eq(itemIndex)
                                rebind(item, mbItem)
                            }
                        }
                    }
                });

                // console.log('players 2 =====')
                // console.log(players)

                let thisItem = $('.reels-list .item').eq(itemIndex)
                setMbIndex(thisItem)
            },
        }
    });

    //   show pop
    $('.reels-list .item').on('click', function(){
        itemIndex = $(this).index();
        swiper.slideTo(itemIndex);
        itemContent($(this))
    });

    //   close
    $('#reels-pop .close').on('click', function(){
        $('#pop-video').prop('src', '');
        $('#reels-pop').hide();

        // 暫停所有影片
        muteAndPauseAll()

        unlockScroll($('body'), true);
    });

    //   prev
    $('#reels-pop .prev').on('click', function(){
        if((itemIndex - 1) < 0){
            itemIndex = itemLength - 1
        }else{
            itemIndex -= 1
        }

        let thisItem = $('.reels-list .item').slice(itemIndex)
        itemContent($(thisItem))
    });

    //   next
    $('#reels-pop .next').on('click', function(){
        if((itemIndex + 1) >= itemLength){
            itemIndex = 0
        }else{
            itemIndex += 1
        }

        let thisItem = $('.reels-list .item').slice(itemIndex)
        itemContent($(thisItem))

    });

    // mb show all desc
    $('.rd-desc').on('click', function () {
        $(this).toggleClass('now')
    });

    $('.reels-tab li').on('click', function(){
        // console.log('被點到了')
        window.location.href = $(this).data('url');
    })

    // pc 版
    function itemContent(item){
        // $('#loading1').show();
        lockScroll($('body'));

        $('#pop-logo').prop('src', $(item).data('logo_pic'));
        $('#pop-company-name').text($(item).data('company_name'));
        $('#pop-desc').text($(item).data('desc'));
        $('#pop-url').prop('href', $(item).data('url'));
        popPlayer.destroy();

        if($(item).data('video_type') == 'local'){
            $('#pop-video').html('<video class="video-content" playsInline muted preload="auto"><source src="'+$(item).data('video')+'" type="video/mp4" /></video>')
        }
        else{
            $('#pop-video').html('<div class="video-content" data-plyr-provider="'+$(item).data('video_type')+'" data-plyr-embed-id="'+$(item).data('embed_id')+'"></div>')
        }

        if($('#reels-pop').is(":visible")){
            partItemContent(item);
        }
        else{
            $('#reels-pop').show(function (){
                partItemContent(item);
            });
        }
    }

    function partItemContent(item){
        if($('#pop-video .video-content').is(":visible")){ // pc show
            popPlayer = new Plyr($('#pop-video .video-content')
                , {
                    autoplay: false, // 開啟 autoplay
                    muted: true,
                    loop: { active: true },
                    controls: ['play', 'progress', 'current-time', 'mute', 'volume'],
                    vimeo: {
                        loop: true
                    }
                }
            );

            // 綁定點擊事件到 player 的容器
            bindPlayerEvent(popPlayer)
            if(!isMobile()){
                // console.log('pc 不靜音');
                popPlayer.on('play', () => {
                    popPlayer.muted = false;
                });
            }

            popPlayer.play();
        }
        else{   // mb show
            setMbIndex(item)
        }
    }

    function setMbIndex(item){    // mb 版
        $('#pop-logo-mb').prop('src', $(item).data('list_logo_pic'));
        $('#pop-company-name-mb').text($(item).data('company_name'));
        $('#pop-desc-mb').text($(item).data('desc'));
        $('#pop-url-mb').prop('href', $(item).data('url'));

        let mbItem = $('.videobox-mb .video-wrapper .video').eq(itemIndex);
        if(mbItem.is(":visible")){
            let id = $(mbItem).data('id');
            // 播放當前
            if (players[id] && players[id].ready && (!players[id].loading)) {
                // console.log('播放當前2 === ' )
                players[id].play().then(() => {
                    // 播放成功後才去暫停其他的影片
                    muteAndPauseAll($('.videobox-mb .video-wrapper .video').eq(itemIndex))
                }).catch(error => {
                    console.warn('播放失敗:', error);
                });

            }
        }
    }

    // 綁定點擊事件到 player 的容器 (pc版好像失效）
    function bindPlayerEvent(player){
        let $container = $(player.elements.container);

        player.off()
        player.on('ready', () => {
            let url = $container.find('iframe').prop('src');
            $container.find('iframe').prop('src', url+'&controls=0');
            player.muted = true;
            let dataId = $('.videobox-mb .video-wrapper .video').eq(itemIndex).data('id'); // 目前顯示的 player 的 id
            let selfId = $container.closest('.video').data('id'); // 這個player 的 id

            if(selfId === dataId){
                player.play();
            }
        });

        player.on('play', () => {
            // let $container = $(player.elements.container);
            // let dataId = $('.videobox-mb .video-wrapper .video').eq(itemIndex).data('id'); // 目前顯示的 player 的 id
            // let selfId = $container.closest('.video').data('id'); // 這個player 的 id
            // console.log('on play 1 ==> selfId: '+ selfId)
            $('#loading1').hide();
        });
    }

    // 暫停所有影片
    function muteAndPauseAll(thisItem) {
        popPlayer.pause()

        let itemId = (thisItem != undefined) ? $(thisItem).data('id'): null;

        $.each(players, function (id, player) {
            if(itemId !== id && player.ready && (!players[id].loading)){
                player.pause();
            }
        });
    }

    function isMobile(){
        let checkMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        if (checkMobile) {
            // console.log("這是行動裝置");
            // 行動裝置相關的程式碼
            return true;
        } else {
            // console.log("這不是行動裝置");
            // 桌面裝置相關的程式碼
            return false;
        }
    }

    function rebind(item, mbItem){
        // const playerIndex = $(item).index();

        const player = new Plyr(mbItem.children('.plyr-player'), {
            autoplay: false,
            muted: true,
            controls: ['play', 'progress', 'current-time'],
            vimeo: {
                loop: true
            }
        });
        players[$(mbItem).data('id')] = player;

        mbItem.children('.mute-toggle').off();
        mbItem.children('.mute-toggle').on('click', function () {
            if (!player) return;
            if ($(this).hasClass('plyr__control--pressed')) {
                // console.log('開聲音:')
                player.muted = false;
                $(this).removeClass('plyr__control--pressed')
                $(this).html('<svg class="icon--not-pressed" aria-hidden="true" focusable="false"><use xlink:href="#plyr-volume"></use></svg>');
            } else {
                // console.log('關聲音:')
                player.muted = true;
                $(this).addClass('plyr__control--pressed')
                $(this).html('<svg class="icon--pressed"><use xlink:href="#plyr-muted"></use></svg>');
            }
        });

        // 綁定點擊事件到 player 的容器
        bindPlayerEvent(player)
    }
});

